import i18n from '@shared/i18n'
import { MediaPayloadType } from '@shared/models/interfaces/quick-messages'
import { MediaInputDevice } from '@shared/utils/models/video-call-config'

import { VideoCallTrackTypes } from '@protos/apps/video_call_track_types_pb'
import { VideoCallTroubleShootKeys } from '@protos/apps/video_call_trouble_shot_keys_pb'

import type { Track } from 'twilio-video'

export const TROUBLE_SHOOT_MESSAGES: Record<VideoCallTroubleShootKeys, string> =
  {
    [VideoCallTroubleShootKeys.UNABLE_TO_HEAR]: i18n.global.t(
      'chat.video.troubleshooting.messages.unableToHear'
    ),
    [VideoCallTroubleShootKeys.UNABLE_TO_SEE]: i18n.global.t(
      'chat.video.troubleshooting.messages.unableToSee'
    ),
    [VideoCallTroubleShootKeys.UNMUTE]: i18n.global.t(
      'chat.video.troubleshooting.messages.unmute'
    ),
  }

export const TRACK_MEDIA_TYPES: Record<VideoCallTrackTypes, MediaPayloadType> =
  {
    [VideoCallTrackTypes.AUDIO]: 'audio',
    [VideoCallTrackTypes.VIDEO]: 'video',
  }

export const TRACK_MEDIA_TYPES_MAP: Record<
  VideoCallTroubleShootKeys,
  VideoCallTrackTypes
> = {
  [VideoCallTroubleShootKeys.UNMUTE]: VideoCallTrackTypes.AUDIO,
  [VideoCallTroubleShootKeys.UNABLE_TO_HEAR]: VideoCallTrackTypes.AUDIO,
  [VideoCallTroubleShootKeys.UNABLE_TO_SEE]: VideoCallTrackTypes.VIDEO,
}

export const trackKindDeviceMap: Record<
  Track['kind'],
  MediaInputDevice | undefined
> = {
  audio: 'microphone',
  video: 'camera',
  data: void 0,
} as const
